











































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {FarmInfo, FarmProfile, FarmProfileCreate, FarmToken} from '@/interfaces';
import { env } from '@/env';
import { commitAddNotification } from '@/store/main/mutations';
import {dispatchCreateFarm, dispatchGetOneFarm, dispatchValidateFarmUrl} from '@/store/farm/actions';
import FarmAuthorizationForm from '@/components/FarmAuthorizationForm.vue';

@Component({
  components: {FarmAuthorizationForm},
})
export default class UserProfileEdit extends Vue {
  public $refs!: {
      authForm: HTMLFormElement,
  };

  // Load environment configs
  public appName = env('appName');
  public openFarmRegistration = env('openFarmRegistration');
  public inviteFarmRegistration = env('inviteFarmRegistration');

  // Query params.
  public farmId: number = 0;
  public apiToken: string = '';

  // Initialize form variables.
  public tags: string = '';
  public scope: string = '';

  // Initialize variables for farm profile.
  public farmInfo: FarmInfo = {
    name: '',
    url: '',
    api_version: '',
  };
  // Initialize variables for the authorization step.
  public authStarted: boolean = false;
  public authFinished: boolean = false;
  public registerNewFarm: boolean = false;
  public registerComplete: boolean = false;
  public authCode: string = '';
  public authState: string = '';
  public authError: string = '';
  public authErrorDialog: boolean = false;
  public authErrorDialogText: string = '';
  public authErrorDialogDescriptionText: string = '';
  public authErrorDescription: string = '';
  public authToken: FarmToken = {
      access_token: '',
      refresh_token: '',
      expires_at: '',
      expires_in: '',
  };

  // Variables for success dialog
  public registerSuccess: boolean = false;
  public reauthorizeSuccess: boolean = false;

  public currentStep: number = 1;
  public steps: object[] = [
    {
      key: 1,
      header: 'farmOS URL',
      complete: false,
      editable: false,
      rules: [],
    },
    {
      key: 2,
      header: 'Authorize',
      complete: false,
      editable: false,
      rules: [],
    },
    {
      key: 3,
      header: 'Verify',
      complete: false,
      editable: false,
      rules: [],
    },

  ];

  public async mounted() {
      // Check for authorization errors.
      this.authError = this.$router.currentRoute.query.error as string;
      this.authErrorDescription = this.$router.currentRoute.query.error_description as string;
      if (this.authError) {
          if (this.authError === 'invalid_scope') {
              this.authErrorDialogText = 'OAuth Scope Error';
              this.authErrorDialogDescriptionText = 'Your farmOS server does not have an Authorization Scope enabled. Ensure this is enabled in /admin/config/farm/oauth ';
              this.authErrorDialog = true;

          } else if (this.authError === 'access_denied') {
              this.authErrorDialogText = 'Authorization Denied';
              this.authErrorDialogDescriptionText = 'You denied the Authorization request. In order to add your farm to the ' + this.appName + ', you must authorize access to your farmOS Server.';
              this.authErrorDialog = true;
          } else {
              commitAddNotification(this.$store, {
                  content: this.authError + ': ' + this.authErrorDescription,
                  color: 'error',
              });
          }
          return;
      }

      // Get authorization code and authorization state
      this.authCode = this.$router.currentRoute.query.code as string;
      this.authState = this.$router.currentRoute.query.state as string;
      if (this.authCode && this.authState) {
          this.currentStep = 2;
          // Finish authorization in the FarmAuthorizationFrom component.
          this.$refs.authForm.finishAuthorization(this.authCode, this.authState);
          return;
      }

      // Save an API Token if provided.
      this.farmId = +this.$router.currentRoute.query.farm_id as number;
      this.apiToken = this.$router.currentRoute.query.api_token as string;

      // If no farm ID is populated, see if we can register a new farm.
      if (!this.farmId) {

        // Check farm registration configuration.
        if (!this.openFarmRegistration && this.inviteFarmRegistration) {
          // Verify an APIToken was provided.
          if (!this.apiToken) {
            commitAddNotification(this.$store, {
              content: 'You cannot register farms without an invitation from the administrator.',
              color: 'error',
            });
            this.$router.push('/');
          }
        }

        if (!this.openFarmRegistration && !this.inviteFarmRegistration) {
          commitAddNotification(this.$store, {
            content: 'You cannot join this aggregator without an invitation from the administrator.',
            color: 'error',
          });
          this.$router.push('/');
          return;
        }
      } else {
        // Authorization is starting from a link with ID and api_token provided.

        if (!this.apiToken) {
          commitAddNotification(this.$store, {
            content: 'You cannot re-authorize farms without an invitation from the administrator.',
            color: 'error',
          });
          this.$router.push('/');
          return;
        }

        // Verify a valid api_token was provided and load farm info.
        const response = await dispatchGetOneFarm(this.$store, { farmID: this.farmId, apiToken: this.apiToken } );
        if (response) {
          this.farmInfo = {
            name: response.farm_name,
            url: response.url,
            api_version: '',
          };
        } else {
          commitAddNotification(this.$store, {
            content: 'Farm not found, cannot authorize.',
            color: 'error',
          });
          this.$router.push('/');
          return;
        }

        this.currentStep = 2;
      }
      this.reset();
  }

  public reset() {
    this.$validator.reset();
  }

  public cancel() {
    this.$router.push('/');
  }

  public async submitUrl() {
    this.$validator.validateAll('farmUrl').then( (isValid) => {
      if (isValid) {
        dispatchValidateFarmUrl(
            this.$store,
            {farmUrl: this.farmInfo.url, apiToken: this.apiToken },
        ).then( (response) => {

          // Check if the farm exists.
          if (response.id === null) {
            this.registerNewFarm = true;
          } else {
            this.farmId = response.id;
          }

          this.apiToken = response.api_token;
          this.currentStep = 2;
        });
      }
    });
  }

  public handleAuthorizationComplete(response) {
    this.authToken = response.token;
    this.farmInfo = {
      name: response.info.name,
      url: response.info.url,
      api_version: response.info.api_version ? response.info.api_version : response.info.version,
    };
    this.currentStep = 3;

    // Display a re-authorize success message.
    if (!this.registerNewFarm) {
      this.reauthorizeSuccess = true;
    }
  }

  public createFarm() {
    this.registerComplete = true;
    this.$validator.validateAll('FarmVerifyForm').then((isValid) => {
      if (isValid && !!this.farmInfo) {
        const newFarm: FarmProfileCreate = {
          farm_name: this.farmInfo.name,
          url: this.farmInfo!.url,
          tags: '',
          token: this.authToken,
          scope: this.scope,
        };
        dispatchCreateFarm(
            this.$store,
            {data: newFarm, apiToken: this.apiToken},
        ).then((response) => {
              this.registerSuccess = true;
              this.farmId = response.id;
            },
        );
      }
    });
  }
}
